export default __webpack_public_path__ + "static/media/safari.03bb2702.svg";